import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import WeakSignalComponent from '../../components/WeakSignalComponent/WeakSignalComponent'

const WeakSignal = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <WeakSignalComponent/>
                </div>
            </div>
        </div>
    )
}

export default WeakSignal
